<template>
  <div class="logo">
    <img class="logo__img" width="75" srcset="static/img/logo.png 1x, static/img/logo@2x.png 2x"  src="static/img/logo.png" :alt="$t('login.title')">
    <!-- <img class="logo__description" width="155" src="static/img/logo_text.svg" :alt="$t('login.title')"> -->
    <h1 class="logo__text">{{ $t('login.title') }}</h1>
  </div>
</template>
<script>
  export default {

  }
</script>

<style lang="scss">
.logo {
  height: 42px;
  display: flex;
  align-items: center;
  white-space: nowrap;

  &__img {
    margin-right: 5px;
    transition: 0.2s;
    @media (max-width: 990px) {
      position: relative;
      top: 6px;
    }
  }

  &__text {
    position: relative;
    display: inline-block;
    margin: 0;
    font-weight: 700;
    font-size: 24px;
    color: #1E5A9F;
    transition: all .4s;
    max-width: 180px;
  }
}
</style>